export default __webpack_public_path__ + "static/0162-7b28320a63da199b85b5dac6007633d5.png";